<template>
  <div class="flex-1 ">
    <label class="text-xs lg:hidden text-gray-900 uppercase truncate pl-1">Row Total</label>
    <div class="relative w-full lg:h-full flex flex-col justify-center rounded rounded-l-none bg-gray-200 border-l border-gray-400">
      <span class="absolute pl-1 text-gray-500 pointer-events-none">{{ settings.currency }}</span>
      <div  class="w-full p-1 lg:pl-4 lg:pr-2 align-middle text-right"
            :class="{ 'line-through' : !active }">{{ rowTotal.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RowTotal',
  props: {
    currency: String,
    qty: Number,
    rate: [Number, String],
    model: Object,
    settings: Object,
    active: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    rowTotal: function() {
      let total = 0
      total = parseFloat(this.qty) * parseFloat(this.rate)

      if(isNaN(total)){
        total = 0
      }

      return total
    }
  }
};
</script>
